import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdfe2d0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Video" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-label" }, "上传图片", -1))
const _hoisted_3 = { class: "upload-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-plus" }, null, -1))
const _hoisted_5 = ["src"]

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { initEmptyParam } from '@/hooks/useInitParam'
import { reactive, ref, nextTick, watch } from 'vue'
import { getListData, getPageListData } from '@/service/main/system'
import { getGeneratUrl } from '@/service/main/fubo/generate'
import useClipboard from 'vue-clipboard3'
import { ElMessage, ElNotification } from 'element-plus'
import { useUpload } from '@/hooks/useUpload'
import type { UploadFile } from 'element-plus/lib/el-upload/src/upload.type'

const IMAGE_TIP =
  '封面请上传 5:4 比例图片，建议尺寸 500×400（PNG/JPG），大小控制在 500KB 以内，否则分享卡片可能剪裁或留白。'
const MAX_IMAGE_SIZE = 500 * 1024
const TARGET_RATIO = 5 / 4
const RATIO_TOLERANCE = 0.02


export default /*#__PURE__*/_defineComponent({
  __name: 'Video',
  setup(__props) {

initEmptyParam()

const otherInfo = reactive({
  image: ''
})
const [
  uploadRef,
  extraData,
  files,
  action,
  beforeUpload,
  ,
  onSuccess,
  onExceed
] = useUpload()
const fileList = ref<any[]>([])
// 本地绑定，确保 el-upload 拿到已就绪的 OSS 地址与表单字段
const uploadAction = ref('')
const uploadExtraData = ref<Record<string, any>>({})
const deptOptions = ref<{ title: string; value: any; disabled?: boolean }[]>(
  []
)
const materialTypeOptions = ref<{ title: string; value: any }[]>([])

const getDictLabel = (
  options: { title: string; value: any }[],
  value: any
) => {
  const hit = options.find((o) => String(o.value) === String(value))
  return hit ? hit.title : value ?? ''
}

const loadDictItems = async (dictCode: string) => {
  const dictRes = await getPageListData('/main/dict/queryByCondition', {
    dictCode,
    pageNo: 1,
    pageSize: 10
  })
  const list = dictRes?.list || dictRes?.records || []
  const dictId = list[0]?.id
  if (!dictId) return []
  const items = await getListData(`/main/dictItem/queryByDictId/${dictId}`, {})
  return Array.isArray(items) ? items : []
}

const getAllDictOptions = async () => {
  const [deptItems, typeItems] = await Promise.all([
    loadDictItems('material_dept_type'),
    loadDictItems('material_type')
  ])

  deptOptions.value = deptItems.map((item: any) => ({
    title: item.itemText,
    value: item.itemValue,
    disabled: item.itemValue == 1 || item.itemValue === '1'
  }))
  materialTypeOptions.value = typeItems.map((item: any) => ({
    title: item.itemText,
    value: item.itemValue
  }))

  const searchDept = searchFormConfig.formItems.find(
    (item) => item.field === 'materialDeptType'
  )
  const searchType = searchFormConfig.formItems.find(
    (item) => item.field === 'materialType'
  )
  const modalDept = modalConfig.formItems.find(
    (item) => item.field === 'materialDeptType'
  )
  const modalType = modalConfig.formItems.find(
    (item) => item.field === 'materialType'
  )

  // 搜索不过滤禁用项，便于按历史数据筛选
  searchDept!.options = deptOptions.value.map(({ title, value }) => ({
    title,
    value
  }))
  searchType!.options = materialTypeOptions.value
  modalDept!.options = deptOptions.value
  modalType!.options = materialTypeOptions.value
}

getAllDictOptions()

const getAllTeacher = async () => {
  const data = await getListData('/main/fuboTeacher/listAll', {})
  const searchTeacher = searchFormConfig.formItems.find(
    (item) => item.field === 'teacherId'
  )

  const modalTeacher = modalConfig.formItems.find(
    (item) => item.field === 'teacherId'
  )
  const options = data.map((item: any) => {
    return { title: item.name, value: item.id }
  })

  searchTeacher!.options = options

  modalTeacher!.options = options
}

getAllTeacher()

const getAllCourse = async () => {
  const data = await getListData('/main/fuboCourse/listAll', {})
  const searchCourse = searchFormConfig.formItems.find(
    (item) => item.field === 'courseId'
  )

  const modalCourse = modalConfig.formItems.find(
    (item) => item.field === 'courseId'
  )
  const options = data.map((item: any) => {
    return { title: item.name, value: item.id }
  })

  searchCourse!.options = options

  modalCourse!.options = options
}

getAllCourse()

const checkImageRatio = (file: File): Promise<boolean> => {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      const ratio = img.width / img.height
      URL.revokeObjectURL(url)
      resolve(
        Math.abs(ratio - TARGET_RATIO) <= TARGET_RATIO * RATIO_TOLERANCE
      )
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      resolve(false)
    }
    img.src = url
  })
}

const wrapBeforeUpload = async (file: UploadFile) => {
  const raw = ((file as any).raw instanceof File ? (file as any).raw : file) as File
  if (!(raw instanceof File)) {
    ElMessage.error('无效的图片文件')
    return false
  }
  const name = (raw.name || '').toLowerCase()
  if (!/\.(jpg|jpeg|png)$/.test(name)) {
    ElMessage.error('仅支持 PNG/JPG 格式')
    return false
  }
  if (raw.size > MAX_IMAGE_SIZE) {
    ElMessage.error('图片大小不能超过 500KB')
    return false
  }
  const ratioOk = await checkImageRatio(raw)
  if (!ratioOk) {
    ElMessage.error('请上传 5:4 比例图片（建议尺寸 500×400）')
    return false
  }
  // 仅允许一张：上传前清空旧图
  files.value = []
  // 与课程/老师页一致：走 useUpload 拉 policy，再由 el-upload 原生直传 OSS
  await beforeUpload(raw as any)
  uploadAction.value = action.value || ''
  uploadExtraData.value = { ...(extraData.value || {}) }
  await nextTick()
  if (!uploadAction.value) {
    ElMessage.error('获取上传地址失败，请重试')
    if (files.value.length) files.value.pop()
    return false
  }
  return true
}

const handleRemove = () => {
  files.value = []
  otherInfo.image = ''
  fileList.value = []
}

const previewVisible = ref(false)
const previewUrl = ref('')
const handlePreview = (file: UploadFile) => {
  previewUrl.value = (file as any).url || ''
  previewVisible.value = true
}

const wrapOnSuccess = (response: any, uploadFile: UploadFile) => {
  onSuccess(response)
  const url = files.value[files.value.length - 1]
  // 强制只保留一张
  files.value = url ? [url] : []
  if (url) {
    otherInfo.image = url
    fileList.value = [
      {
        name: uploadFile.name || 'image',
        url
      }
    ]
  }
}

const wrapOnExceed = (elFiles: any[]) => {
  files.value = []
  fileList.value = []
  otherInfo.image = ''
  onExceed(elFiles)
}

const resetModalExtra = () => {
  otherInfo.image = ''
  fileList.value = []
  files.value = []
  uploadAction.value = ''
  uploadExtraData.value = {}
  uploadRef.value?.clearFiles?.()
}

const clearAddForm = () => {
  defaultInfo.value = {}
  const formData = pageModalRef.value?.formData
  if (formData) {
    modalConfig.formItems.forEach((item) => {
      formData[item.field] = undefined
    })
  }
}

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增复播视频'
  resetModalExtra()
  defaultInfo.value = { pcDisplay: true }
}

const editCb = (item: any) => {
  modalTitle.value = '编辑复播视频'
  // 提交仍用 image；回显无 image 时用 cover 仅作预览
  otherInfo.image = item?.image || ''
  const displayUrl = item?.image || item?.cover || ''
  if (displayUrl) {
    fileList.value = [
      {
        name:
          'image' +
          displayUrl.substring(displayUrl.lastIndexOf('.') || displayUrl.length),
        url: displayUrl
      }
    ]
    // 只有真实 image 才写入 files，避免把 cover 当成 image 提交
    files.value = item?.image ? [item.image] : []
  } else {
    files.value = []
    fileList.value = []
  }
}

const handleValid = () => {
  otherInfo.image = files.value.length > 0 ? files.value[0] : ''
  return true
}

const { toClipboard } = useClipboard()

const generate = async (id: string) => {
  const url = await getGeneratUrl(id)
  try {
    await toClipboard(url)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

// 弹窗关闭后清空上传与新增表单，避免下次打开残留
watch(
  () => pageModalRef.value?.dialogVisible,
  (visible) => {
    if (visible === false) {
      const wasAdd = pageModalRef.value?.isAdd
      resetModalExtra()
      if (wasAdd) {
        clearAddForm()
      }
    }
  }
)
const handleQrCode = (row: any) => {
  const url = `/main/fuboGenerate/generate/qrcode/${row.id}`
  getPageListData(url, null, 'blob').then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = `${row.title}.jpg`
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "fuboVideo",
      deleteTip: "确认删除此视频吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onQrCodeClick: handleQrCode
    }, {
      cover: _withCtx((scope) => [
        _createVNode(_component_el_image, {
          style: {"width":"60px","height":"80px"},
          src: scope.row.cover,
          fit: "fill"
        }, null, 8, ["src"])
      ]),
      image: _withCtx((scope) => [
        (scope.row.image)
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              style: {"width":"60px","height":"48px"},
              src: scope.row.image,
              fit: "cover"
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      materialDeptType: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(getDictLabel(deptOptions.value, scope.row.materialDeptType)), 1)
      ]),
      materialType: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(getDictLabel(materialTypeOptions.value, scope.row.materialType)), 1)
      ]),
      generate: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          onClick: ($event: any) => (generate(scope.row.id))
        }, {
          default: _withCtx(() => [
            _createTextVNode("点击复制")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "fuboVideo",
      width: "720px",
      otherInfo: otherInfo,
      validOtherInfo: handleValid
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["video-image-upload", { 'hide-upload': fileList.value.length >= 1 }])
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_upload, {
              ref_key: "uploadRef",
              ref: uploadRef,
              "auto-upload": true,
              action: uploadAction.value,
              data: uploadExtraData.value,
              "file-list": fileList.value,
              "before-upload": wrapBeforeUpload,
              "list-type": "picture-card",
              accept: ".jpg,.jpeg,.png",
              "on-success": wrapOnSuccess,
              "on-exceed": wrapOnExceed,
              "on-remove": handleRemove,
              "on-preview": handlePreview,
              limit: 1
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["action", "data", "file-list"]),
            _createElementVNode("div", { class: "el-upload__tip" }, _toDisplayString(IMAGE_TIP))
          ]),
          _createVNode(_component_el_dialog, {
            modelValue: previewVisible.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((previewVisible).value = $event)),
            title: "预览",
            width: "40%"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: previewUrl.value,
                alt: "预览图片",
                style: {"width":"100%"}
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 2)
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})